// The same loose venue match as the backend's venueKeySql: case, punctuation, spaces, the word
// "the", "&" vs "and" and US spellings don't count. Keep the two in step.
export const venueKey = (name) => String(name || '')
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/\btheater\b/g, 'theatre')
  .replace(/\bcenter\b/g, 'centre')
  .replace(/\bthe\b/g, '')
  .replace(/[^a-z0-9]/g, '');

// The band's past venues, one entry per venue, newest first. The name is the one used most
// recently; location and postcode come from the most recent gig that had them.
export function pastVenues(gigs, excludeGigId = null) {
  const byKey = new Map();
  const newestFirst = [...gigs]
    .filter(g => g.id !== excludeGigId && venueKey(g.venue_name))
    .sort((a, b) => String(b.gig_date || '').localeCompare(String(a.gig_date || '')));
  for (const g of newestFirst) {
    const key = venueKey(g.venue_name);
    const v = byKey.get(key) || { key, name: g.venue_name.trim(), location: '', postcode: '', count: 0, lastDate: g.gig_date };
    v.count += 1;
    if (!v.location && g.venue_location) v.location = g.venue_location;
    if (!v.postcode && g.venue_postcode) v.postcode = g.venue_postcode;
    byKey.set(key, v);
  }
  return [...byKey.values()];
}
